module.exports = __webpack_public_path__ + "static/media/ic_chat_download.44cb836e.svg";